import React from "react";
import { useForm } from "react-hook-form";
import {
    ContentSection,
    DropzoneContentSection,
    Form,
    FormActions,
    Grid,
    GridColumn,
    GridRow,
    ValidationResult
} from "sprint-common-web";

import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { ordersRoutes } from "../../OrdersRoutes";
import { useImportOrdersForm } from "./useImportOrdersForm";
import { BuzzOrderValidationSummary } from "./validation-result/BuzzOrderValidationSummary";

export const ImportOrdersForm = (): JSX.Element => {
    const {
        projectedCloudOrders,
        groupedCloudOrdersFailures,
        columnsFailures,
        fileMetadataFailures,
        isFileValidating,
        isFileValid,
        isFileValidated,
        goToOrderListing,
        validateFile,
        importOrderList,
        handleFileMetadataError
    } = useImportOrdersForm();

    const { handleSubmit, formState } = useForm();

    const onDropFile = async (orderFile: File) => {
        await validateFile(orderFile);
    };

    const onDropFileError = (validationResult: ValidationResult) => {
        handleFileMetadataError(validationResult);
    };

    const importOrders = async () => {
        await importOrderList();
    };

    return (
        <>
            <PageHeader>
                <HeaderBreadcrumb routes={ordersRoutes} />
            </PageHeader>
            <Grid>
                <GridRow>
                    <GridColumn sm={3}>
                        <DropzoneContentSection
                            onDropFile={onDropFile}
                            onDropFileError={onDropFileError}
                            isLoading={isFileValidating}
                            disabled={formState.isSubmitting}
                            accept=".xlsx,.xls"
                            maxFileSizeInMegabytes={1}
                        />
                    </GridColumn>
                    {(isFileValidated || isFileValid) && (
                        <Form onSubmit={handleSubmit(importOrders)}>
                            <GridColumn sm={9}>
                                <ContentSection
                                    header={
                                        isFileValid
                                            ? `${projectedCloudOrders.length} orders to import`
                                            : "Validation summary"
                                    }
                                    style={{ minHeight: 400 }}
                                >
                                    <BuzzOrderValidationSummary
                                        groupedCloudOrdersFailures={groupedCloudOrdersFailures}
                                        projectedCloudOrders={projectedCloudOrders}
                                        columnsFailures={columnsFailures}
                                        fileMetadataFailures={fileMetadataFailures}
                                        isFileValid={isFileValid}
                                        isFileValidated={isFileValidated}
                                    />
                                </ContentSection>
                            </GridColumn>
                            <FormActions
                                onCancel={goToOrderListing}
                                submitDisabled={!isFileValid || projectedCloudOrders.length === 0}
                                isLoading={formState.isSubmitting}
                            />
                        </Form>
                    )}
                </GridRow>
            </Grid>
        </>
    );
};
